import * as React from 'react';
import { InlineText2, Select } from '@cian/ui-kit';
import { IOption } from '@cian/ui-kit/types';
import { TNumberInputs } from '../../types/filter';
import * as styles from '../Filters/Filters.css';

interface IDeadlineDropdownProps {
  options: IOption[];
  selectedDeadline: TNumberInputs | 'any';
  onChange: (value: number) => void;
}

export function DeadlineDropdown({ options, selectedDeadline, onChange }: IDeadlineDropdownProps) {
  return (
    <>
      <InlineText2>Срок сдачи</InlineText2>

      <div className={styles['input__wrapper']}>
        <Select options={options} value={selectedDeadline} width={150} onChange={onChange} />
      </div>
    </>
  );
}
